import { AuthService } from "./../../shared/models/auth.service";
import { TranslateService } from "./../../shared/translate/translate.service";
import { FlatPickrModel } from "./../../plugins/flatpickr/flatpickr.model";
import {
  WeGoConfig,
  Marker,
  RoleLevel,
  Permission,
  Entity
} from "./../../shared/config";
import { Component, OnInit, OnDestroy, ViewChild } from "@angular/core";
import { NgForm } from "@angular/forms";
import { SharedVehicleGroupModel } from "../models/sharedvehiclegroup.model";
import { SharedVehicleGroupService } from "../models/sharedvehiclegroup.service";
import { Router, ActivatedRoute } from "@angular/router";
import {
  IKeyValueInterface,
  IAPIResponse,
  ApplicationRouteURL,
  UserRoles,
  PermissionType
} from "../../shared/config";
import { CompanyService } from "../../company/models/company.service";
import { Location } from "@angular/common";
import { DropdownModel } from "../../report/models/report-filter.model";
import { PrePostTripQuestionComponent } from "../../pre-post-trip-question/components/pre-post-trip-question.component";
import { BasePermissionModel } from "../../shared/models/base-permission-model";
import {ValidateLicense24IdCheckOption} from "../../instance/models/validate-license-24idcheck-option";
import {InstanceService} from "../../instance/models/instance.service";

@Component({
  selector: "wego-SharedVehicleGroup",
  template: require('../views/sharedvehiclegroup-update.component.html'),
  providers: [SharedVehicleGroupService, CompanyService, InstanceService]
})
export class SharedVehicleGroupUpdateComponent implements OnInit, OnDestroy {
  basePermissionModel: BasePermissionModel;
  public sharedvehiclegroupHashId: string;
  private sub: any;
  public timeFormat: string = WeGoConfig.FLATPICKR_TIME_FORMAT;
  apiResponse: IAPIResponse;
  submitted = false;
  model: SharedVehicleGroupModel;
  submitModel: SharedVehicleGroupModel;
  companyList: DropdownModel[];
  errorModel: IKeyValueInterface[];
  message: string;
  errorMessage: string;
  isEditMode: boolean;
  urlDefaultPage: string;
  urlSVGList: string;
  locationModelField: string;
  pageName: string;
  accessDeniedErrorCode: string;
  TwoFaEnabled: boolean;

  apiErrorMsg: string;
  markerInfo: Marker;
  //WEGO2DEV-325(Settings for Dashboard statuses)
  //timeIntervalList : any;
  //bookedBeforeTimeIntervalList : any;

  roleLevel = RoleLevel;
  public selectedCompany: string = "";
  flatPickrConfigTimeFrom: FlatPickrModel;
  flatPickrConfigTimeTo: FlatPickrModel;
  private popupMsg: string;
  private module: string;
  private breadCrumbTitle: string;
  private breadCrumbList: string;
  public isAuthorizedForPrePostTrip: boolean;
  public language: string = 'en';

  @ViewChild("successPopup") public successPopup: any;
  @ViewChild('TwoFasuccessPopup') public TwoFasuccessPopup: any;
  @ViewChild("googleMapComp") public googleMapComp: any;
  @ViewChild("geoLocationModal") public geoLocationModal: any;
  @ViewChild("prePostTripQuestionSection")
  public prePostTripQuestionSection: PrePostTripQuestionComponent;
  popupTitle: string;
  private showIdCheckConfig: boolean = false;

  constructor(
    private sharedvehiclegroupService: SharedVehicleGroupService,
    private companyService: CompanyService,
    private instanceService: InstanceService,
    private authService: AuthService,
    private activeRoute: ActivatedRoute,
    private translate: TranslateService,
    private router: Router,
    private locationService: Location
  ) { }

  ngOnInit() {
    this.accessDeniedErrorCode = "412";
    this.pageName = "SharedVehicleGroup";
    this.module = this.translate.instant("LblSharedVehicleGroup");
    this.flatPickrConfigTimeFrom = this.SetDefaultFlatTimePickrConfig();
    this.flatPickrConfigTimeTo = this.SetDefaultFlatTimePickrConfig();

    this.urlDefaultPage = this.authService.GetURL(
      ApplicationRouteURL.URL_DEFAULT_PAGE
    );
    this.urlSVGList = this.authService.GetURL(ApplicationRouteURL.URL_SVG_LIST);
    this.model = new SharedVehicleGroupModel();

    this.sub = this.activeRoute.params.subscribe(params => {
      this.sharedvehiclegroupHashId = params["id"] || "";
      if (this.sharedvehiclegroupHashId != "") {
        this.GetCompanyListDropdown(PermissionType.EDIT);
      } else {
        this.GetCompanyListDropdown(PermissionType.INSERT);
      }
    });
    this.IsAuthorizedForPrePostTripQuestion();
  }

  ngAfterViewInit() {
    // viewChild is set after the view has been initialized
    //
  }

  private SetDefaultFlatTimePickrConfig() {
    let flatPickrConfig = new FlatPickrModel();
    flatPickrConfig.enableTime = true;
    flatPickrConfig.time_24hr = true;
    flatPickrConfig.noCalendar = true;
    flatPickrConfig.dateFormat = this.timeFormat;
    return flatPickrConfig;
  }

  onSubmit(forms: any) {
    this.submitted = true;
    this.AddNewSharedVehicleGroup();
  }

  public GetSharedVehicleGroupDetails() {
    //this.sub = this.activeRoute.params.subscribe(params => {
    // this.sharedvehiclegroupHashId = params["id"] || "";
    if (this.sharedvehiclegroupHashId != "") {
      this.isEditMode = true;
      this.sharedvehiclegroupService
        .GetSharedVehicleGroupHashId(this.sharedvehiclegroupHashId)
        .subscribe(
          res => {
            this.model = res.data;
            this.language = this.model.instanceLanguage;
            this.GetTwoFaEnabled();
            this.GetInstanceDetails();
          },
          error => {
            this.message = this.authService.HandleErrorStatusCode(error);
          },
          () => console.log(this.model)
        );
    } else {
      this.isEditMode = false;
    }
    //});
    this.breadCrumbTitle = this.isEditMode
      ? this.translate.instant("LblEditPage", [this.module])
      : this.translate.instant("LblAddPage", [this.module]);
    this.breadCrumbList = this.translate.instant("LblListPage", [this.module]);
  }

  public GetCompanyListDropdown(permissionType: string) {
    this.companyService
      .GetCompanyListDropdownForAddUpdatePage(this.pageName, permissionType)
      .subscribe(
        res => {
          this.companyList = res.data;
          this.model.companyMasterHashId =
            this.model.companyMasterHashId || this.companyList.length > 0
              ? ""
              : "";
          if (this.companyList.length == 0) {
            this.authService.HandleErrorStatusCode(this.accessDeniedErrorCode);
          }

          if (this.companyList && this.companyList.length > 0) {
            if (
              !this.model.companyMasterHashId &&
              this.companyList.length == 1
            ) {
              this.model.companyMasterHashId = this.companyList[0].keyHash;

            }
          }
        },
        error => {
          this.errorMessage = <any>error;
        },
        () => this.GetSharedVehicleGroupDetails()
      );

  }

  public AddNewSharedVehicleGroup() {
    this.sharedvehiclegroupService
      .AddSharedVehicleGroupModel(this.model)
      .subscribe(
        res => {
          if (res.data) {
            this.popupMsg = this.isEditMode
              ? this.translate.instant("LblRecordUpdatedSuccess", [this.module])
              : this.translate.instant("LblRecordAddedSuccess", [this.module]);
            this.popupTitle = this.translate.instant('LblSuccess');
            this.ShowSuccessPopup();
          } else {
            this.errorModel = res.error;
          }
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public Geofence() {
    this.companyService
      .IsGeofenceEnables(this.model.companyMasterHashId)
      .subscribe(
        res => {
          this.model.isGefenceEnabled = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetLocationMode() {
    this.companyService
      .GetLocationMode(this.model.companyMasterHashId)
      .subscribe(
        res => {
          this.model.isHomeLocationEnabled = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public OdometerConfig() {
    this.companyService
      .IsOdometerConfigEnabled(this.model.companyMasterHashId)
      .subscribe(
        res => {
          this.model.isOdometerConfiguration = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  onChangeSelectedField(selectedCompany: any) {
    this.IsAuthorizedForPrePostTripQuestion();
    this.model.companyMasterHashId = selectedCompany;
    this.Geofence();
    this.GetLocationMode();
    this.OdometerConfig();
    this.GetInstanceLaguage();
    this.GetTwoFaEnabled();
    this.GetInstanceDetails();
  }

  public GetInstanceDetails(){
    if (this.model && this.model.companyMasterHashId) {
      this.instanceService
          .GetInstanceByCompanyHashId(this.model.companyMasterHashId)
          .subscribe(res => {
            this.showIdCheckConfig = res.data.validateLicense24IDCheck == ValidateLicense24IdCheckOption.Optional;
          })
    }
  }

  public GetInstanceLaguage() {
    this.companyService
      .GetInstanceLanguage(this.model.companyMasterHashId)
      .subscribe(
        res => {
          this.language = res.data;
        },
        error => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
        }
      );
  }

  public GetTwoFaEnabled() {
    if (this.model && this.model.companyMasterHashId) {
      this.companyService
        .IsTwoFaEnabled(this.model.companyMasterHashId)
        .subscribe(
          res => {
            this.TwoFaEnabled = res.data;
          },
          error => {
            this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);
          }
        );
    } else {
      this.TwoFaEnabled = false;
    }
  }

  ngOnDestroy() {
    if (this.sub) {
      this.sub.unsubscribe();
    }
  }

  public ShowSuccessPopup(): void {
    this.successPopup.show();
  }

  public HideSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public ConfirmSuccessPopup(): void {
    this.successPopup.hide();
    this.OnBackClick();
  }

  public OnBackClick() {
    this.locationService.back();
  }
  public GetGeoLocation(event: any) {
    if (this.model) {
      let locationData = event.GeoLocationData;
      this.model.geofenceAttributeModel.address = locationData.label;
      this.model.geofenceAttributeModel.latitude = locationData.lat;
      this.model.geofenceAttributeModel.longitude = locationData.lng;
    }
  }
  public GetAddress(place: Object) {
    this.model.geofenceAttributeModel.address = place["address"];
    this.model.geofenceAttributeModel.latitude = place["lat"];
    this.model.geofenceAttributeModel.longitude = place["log"];
    this.model.geofenceAttributeModel.address = place["useraddressInput"];
  }

  // public onConfirmHomeAddress(event: any) {
  //   if (this.model) {
  //     let locationData = event;
  //     this.model.homeLocationModel.address = locationData.address;
  //     this.model.homeLocationModel.latitude = locationData.lat;
  //     this.model.homeLocationModel.longitude = locationData.long;
  //   }
  // }

  //  public GetHomeAddress(place: Object) {
  //     this.model.homeLocationModel.address = place['address'];
  //     this.model.homeLocationModel.latitude = place['lat'];
  //     this.model.homeLocationModel.longitude = place['lng'];
  //   }

  public GeofenceLocation() {
    this.locationModelField = "geofence";
    this.geoLocationModal.show(
      this.model.geofenceAttributeModel.address,
      this.model.geofenceAttributeModel.latitude,
      this.model.geofenceAttributeModel.longitude
    );
  }

  public ResetLocationField(locationModelField: string) {
    if (locationModelField == "home") {
      this.model.homeLocationModel.address = "";
      this.model.homeLocationModel.latitude = "0";
      this.model.homeLocationModel.longitude = "0";
    } else {
      this.model.geofenceAttributeModel.address = "";
      this.model.geofenceAttributeModel.latitude = "0";
      this.model.geofenceAttributeModel.longitude = "0";
    }
  }

  public SearchHomeAddress() {
    this.locationModelField = "home";
    this.geoLocationModal.show(
      this.model.homeLocationModel.address,
      this.model.homeLocationModel.latitude,
      this.model.homeLocationModel.longitude
    );
  }

  public onConfirm($event: any) {
    if (this.locationModelField == "home") {
      this.model.homeLocationModel.address = $event.address;
      this.model.homeLocationModel.latitude = $event.lat;
      this.model.homeLocationModel.longitude = $event.long;
    } else {
      this.model.geofenceAttributeModel.address = $event.address;
      this.model.geofenceAttributeModel.latitude = $event.lat;
      this.model.geofenceAttributeModel.longitude = $event.long;
    }
  }

  changeOfOdometerTimeInterval() {
    if (this.model.odometerConfigurationModel.timeInterval == "PERBOOKING")
      this.model.odometerConfigurationModel.frequency = "";
  }

  public ResetCookies() {
    this.sharedvehiclegroupService.ResetTwoFaCookies(this.sharedvehiclegroupHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblCookieResetSuccess', [this.module]);
            this.popupTitle = this.translate.instant('LblSuccess');
            this.ShowTwoFaPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblCookieResetFailed');
            this.popupTitle = this.translate.instant('LblError');
            this.ShowTwoFaPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);

        });
  }

  public ResetTwoFA() {
    this.sharedvehiclegroupService.ResetTwoFaKeys(this.sharedvehiclegroupHashId)
      .subscribe(
        (res: any) => {
          if (res.data) {
            this.popupMsg = this.translate.instant('LblKeyResetSuccess', [this.module]);
            this.popupTitle = this.translate.instant('LblSuccess');
            this.ShowTwoFaPopup();
          }
          else {
            this.popupMsg = this.translate.instant('LblKeyResetFailed');
            this.popupTitle = this.translate.instant('LblError');
            this.ShowTwoFaPopup();
          }
        },
        (error: any) => {
          this.apiErrorMsg = this.authService.HandleErrorStatusCode(error);

        });
  }

  public ShowTwoFaPopup(): void {
    this.TwoFasuccessPopup.show();
  }

  public ConfirmTwoFaPopup(): void {
    this.TwoFasuccessPopup.hide();
  }

  public OnPrePostTripQuestionSetting($event: any) {
    this.model.customTripQuestionList = $event.customTripQuestionList;
  }

  public IsAuthorizedForPrePostTripQuestion() {
    let primaryPermissionType: string;
    let entity: string = '';
    let entityHashId: string = '';
    if (this.sharedvehiclegroupHashId && this.sharedvehiclegroupHashId != "") {
      primaryPermissionType = PermissionType.EDIT;
      entity = Entity.SVG;
      entityHashId = this.sharedvehiclegroupHashId;
    } else {
      primaryPermissionType = PermissionType.INSERT;
      entity = Entity.COMPANY;
      entityHashId = this.model.companyMasterHashId;
    }
    this.authService
      .IsAuthorizedForPrePostQuestion(
        Permission.PR_SHARED_VEHICLE_GROUP_OVERVIEW,
        primaryPermissionType,
        Permission.PR_PREPOST_TRIP_QUESTIONS_UPDATE,
        PermissionType.VIEW,
        entity,
        entityHashId
      )
      .subscribe(
        res => {
          this.isAuthorizedForPrePostTrip = res.data.view;
          this.basePermissionModel = res.data;
          console.log(this.prePostTripQuestionSection);
        },
        error => {
          this.authService.HandleErrorStatusCode(error);
        },
        () => {
          setTimeout(() => {
            if (this.isAuthorizedForPrePostTrip) {
              this.prePostTripQuestionSection.GetPrePostTripQuestionList(
                null,
                this.sharedvehiclegroupHashId ? null : this.model.companyMasterHashId,
                this.sharedvehiclegroupHashId,
                null,
                this.basePermissionModel,
                !this.sharedvehiclegroupHashId
              );
            }
          }, 1000);
        }
      );
  }

  private LicenseCheckChange() {
    if (this.model.licenseCheckEnabled == false) {
      this.model.bookingLicenseCheckEnabled = false
    }
  }

  private TrackAndTraceChange() {
    if (this.model.trackAndTraceEnabled == true) {
      this.model.createBookingDisabled = true;
      this.model.editBookingDisabled = true;
    }
  }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/sharedvehiclegroup/components/sharedvehiclegroup-update.component.ts